export default __webpack_public_path__ + "static/media/alternativesIcon_lightBorder_gray.b2582f8b.svg";